import type {
  FilterConfig,
  FilterDefinition,
  FilterHandler,
} from '../engine/types';
import {
  FilterId,
  FilterType,
  type MultiFilter,
  type RangeFilter,
} from '../types/filters';
import { payDefinition, payHandler } from './pay';

export const multiPayDefinition: FilterDefinition<MultiFilter<RangeFilter>> = {
  id: FilterId.MULTI_PAY,
  name: 'Pay',
  type: FilterType.MULTI,
  wrappedFilterId: FilterId.PAY,
  instances: [],
  isVisible: true,
};

export const multiPayHandler: FilterHandler<MultiFilter<RangeFilter>> = {
  isActive(currentFilterState: MultiFilter<RangeFilter>) {
    return currentFilterState.instances.some((instance) =>
      payHandler.isActive(instance)
    );
  },

  isDefault(
    currentFilterState: MultiFilter<RangeFilter>,
    _definition: FilterDefinition<MultiFilter<RangeFilter>>
  ) {
    return currentFilterState.instances.length === 0;
  },

  getEffectiveFilter(
    currentFilterState: MultiFilter<RangeFilter>,
    _definition: FilterDefinition<MultiFilter<RangeFilter>>,
    config: FilterConfig
  ) {
    const effectiveInstances = currentFilterState.instances.map((instance) =>
      payHandler.getEffectiveFilter(instance, payDefinition, config)
    );
    return { ...currentFilterState, instances: effectiveInstances };
  },
};
